/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { MicrosoftCalendarRequest } from '@/infrastructure/network/Monitaro/schema/models'
import {
  FetchCalendarMicrosoft,
  DeleteCalendarMicrosoft,
  RelationCalendarMicrosoft,
  PutCalendarMicrosoft,
  CleaningCalendarMicrosoft
} from '@/infrastructure/network/Monitaro/requests/calendar_microsoft'

export default class CalendarMicrosoft extends MonitaroGatewayBase {
  async FetchCalendarMicrosoft() {
    const { calendars } = await this.apiClient.request(new FetchCalendarMicrosoft())
    return calendars
  }

  async DeleteCalendarMicrosoft() {
    const { result } = await this.apiClient.request(new DeleteCalendarMicrosoft())
    return result
  }

  async RelationCalendarMicrosoft(id: string) {
    return await this.apiClient.request(new RelationCalendarMicrosoft(id))
  }

  async PutCalendarMicrosoft(id: string, params: MicrosoftCalendarRequest) {
    const { result } = await this.apiClient.request(new PutCalendarMicrosoft(id, params))
    return result
  }

  async CleaningCalendarMicrosoft(id: string) {
    const { result } = await this.apiClient.request(new CleaningCalendarMicrosoft(id))
    return result
  }
}
